import React from 'react';
import { createStyleSheet, useStyleSheet, View, Text, Divider, Button, useThemeContext } from '@gopeerproject/ui-kit';
import { PortalModal } from '../../../PortalModal';
export const UnsupportedFilesModal = ({ items, onClose }) => {
    const styles = useStyleSheet(getStyles);
    const { color } = useThemeContext();
    return (React.createElement(PortalModal, { onClose: onClose },
        React.createElement(View, { style: styles.container },
            React.createElement(View, { style: styles.main },
                React.createElement(Text, { type: 'heading', size: 'h6' }, "Unsupported file types"),
                React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular', style: styles.description }, "Sorry, following files cannot be uploaded to GoPeer:"),
                React.createElement("ul", null, items.map((file) => (React.createElement("li", { key: file.name, style: { color: color.invert2.p56 } },
                    React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular', style: styles.filename, numberOfLines: 1 }, file.name))))),
                React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular', style: styles.description },
                    "Try uploading a .zip version of",
                    ' ',
                    items.length === 1 ? 'this file' : 'these files',
                    " instead")),
            React.createElement(Divider, { type: 'horizontal', style: styles.divider }),
            React.createElement(View, { style: styles.actions },
                React.createElement(Button, { type: 'tertiary', accent: 'default', text: 'Got it', size: 'md', onPress: () => {
                        onClose();
                    } })))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        maxWidth: '100%',
        width: 420
    },
    main: {
        padding: size.K
    },
    description: {
        color: color.invert2.p56,
        marginTop: size.C
    },
    filename: {
        color: color.invert2.p56
    },
    divider: {
        marginHorizontal: size.K
    },
    actions: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: size.G
    }
}));
//# sourceMappingURL=UnsupportedFiles.js.map